import React from "react";
import {
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarNav,
  MDBNavItem,
  MDBNavLink,
  MDBNavbarToggler,
  MDBCollapse,
  MDBIcon,
  MDBDropdown,
} from "mdbreact";
import { Link } from "react-router-dom";
import * as ROUTES from "../../constants/routes";
import Logotipo_inicio from "../../images/Logotipo_web.png";

class Navbar extends React.Component {
  state = {
    collapsed: false,
  };

  handleTogglerClick = () => {
    const { collapsed } = this.state;
    this.setState({
      collapsed: !collapsed,
    });
  };

  render() {
    const { collapsed } = this.state;
    const { onLinkClick } = this.props;

    const overlay = (
      <div
        id="sidenav-overlay"
        style={{ 
          backgroundColor: "#34406B" ,
          height: "35vh"
        }}
        onClick={this.handleTogglerClick}
      />
    );
    return (
      <div>
        <MDBNavbar
          expand="md lg xl"
          fixed="top"
          scrolling
          style={{
            marginTop: "0px",
            height: "70px",
            backgroundColor: "#293253",
            //zIndex: "10",
          }}
        >
          <MDBNavbarBrand>
            <Link to={ROUTES.HOME}>
              <img src={Logotipo_inicio} height="50" alt="Tovo" />
            </Link>
          </MDBNavbarBrand>
          <MDBNavbarToggler onClick={this.handleTogglerClick}>
            <MDBIcon icon="bars" className="white-text pr-3" />
          </MDBNavbarToggler>
          <MDBCollapse isOpen={collapsed} navbar>
            <MDBNavbarNav right>
              <MDBNavItem>
                <MDBNavLink
                  className="h1_fey"
                  to={ROUTES.HOME}
                  onClick={onLinkClick}
                  style={{ color: "#ffffff" }}
                >
                  {/* <MDBIcon icon="search" className="mr-3" /> */}
                  Inicio
                </MDBNavLink>
              </MDBNavItem>
              <MDBNavItem>
                <MDBNavLink
                  className="h1_fey"
                  to={ROUTES.PASSENGERS}
                  onClick={onLinkClick}
                  style={{ color: "#ffffff" }}
                >
                  {/* <MDBIcon icon="search" className="mr-3" /> */}
                  Pasajeros
                </MDBNavLink>
              </MDBNavItem>
              <MDBNavItem>
                <MDBNavLink
                  className="h1_fey"
                  to={ROUTES.DRIVERS}
                  onClick={onLinkClick}
                  style={{ color: "#ffffff" }}
                >
                  {/* <MDBIcon icon="search" className="mr-3" /> */}
                  Conductores
                </MDBNavLink>
              </MDBNavItem>
              <MDBNavItem>
                <MDBNavLink
                  className="h1_fey"
                  to={ROUTES.QUESTIONS}
                  onClick={onLinkClick}
                  style={{ color: "#ffffff" }}
                >
                  Preguntas frecuentes
                </MDBNavLink>
              </MDBNavItem>
              <MDBNavItem>
                <MDBNavLink
                  className="h1_fey"
                  to="#"
                  onClick={() => {
                    window.open("https://app.tovo.com.ec/", "_blank");
                  }}
                  style={{ color: "#ffffff" }}
                >
                  {/* <MDBIcon icon="search" className="mr-3" /> */}
                  Ir a la aplicación
                </MDBNavLink>
              </MDBNavItem>

              {/* <MDBNavItem>
                  <MDBNavLink to={ROUTES.SEARCH} onClick={onLinkClick}>
                    <MDBIcon icon="search" className="mr-3" />
                    BUSCAR
                  </MDBNavLink>
                </MDBNavItem> */}
              <MDBNavItem>
                <MDBDropdown>
                  {/* <MDBDropdownToggle nav caret>
                      <MDBIcon icon="user" className="mr-3" />
                      {this.props.firebase.currentUser() == null
                        ? ""
                        : this.props.firebase.currentUser().displayName}
                    </MDBDropdownToggle> */}

                  {/* {this.props.firebase.currentUser() == null ? (
                      <MDBDropdownMenu>
                        <MDBDropdownItem>
                          <Link to={ROUTES.LOGIN}>
                            <MDBIcon icon="briefcase" className="mr-3" />
                            Iniciar sesion
                          </Link>
                        </MDBDropdownItem>
                      </MDBDropdownMenu>
                    ) : (
                      <MDBDropdownMenu>
                        <MDBDropdownItem>
                          <Link to={ROUTES.BOOKINGS}>
                            <MDBIcon icon="briefcase" className="mr-3" />
                            Tus reservas
                          </Link>
                        </MDBDropdownItem>
                        <MDBDropdownItem>
                          <Link to={ROUTES.TRIPS}>
                            <MDBIcon icon="car" className="mr-3" />
                            Tus viajes
                          </Link>
                        </MDBDropdownItem>
                        <MDBDropdownItem>
                          <Link to={ROUTES.CHATS}>
                            <i className="fa fa-comment rotate-icon mr-3" />
                            Mensajes
                          </Link>
                        </MDBDropdownItem>
                        <MDBDropdownItem>
                          <Link to={ROUTES.PROFILE}>
                            <MDBIcon icon="user" className="mr-3" />
                            Perfil
                          </Link>
                        </MDBDropdownItem>
                        <MDBDropdownItem divider />
                        <MDBDropdownItem
                          onClick={() => {
                            this.props.firebase.doSignOut();
                          }}
                        >
                          <i className="fa fa-sign-out-alt mr-3" />
                          Cerrar sesión
                        </MDBDropdownItem>
                      </MDBDropdownMenu>
                    )} */}
                </MDBDropdown>
              </MDBNavItem>
            </MDBNavbarNav>
          </MDBCollapse>
        </MDBNavbar>
        {collapsed && overlay}
      </div>
    );
  }
}

export default Navbar;
